import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';

import {UserLink} from 'src/components/links';
import {
    selectRecentlyViewedUsers,
} from 'src/hooks/recently-viewed/services/recently-viewed-slice';
import {getRecentlyViewedUsers} from 'src/openapi/admin/apis/GetRecentlyViewedUsersApi';
import {useAppDispatch} from 'src/store/hooks';

import {FormSection} from '@pb/kit-component-form-section';
import {Scroll} from '@pb/kit-component-scroll';

import {
    recentlyViewedSection,
    recentlyViewedSectionRecord,
    recentlyViewedSectionRecordsList,
} from './recently-viewed-section.module.styl';


export const RecentlyViewedUsers = () => {
    const apiDispatch = useAppDispatch();
    const recentlyViewedUsers = useSelector(selectRecentlyViewedUsers);

    useEffect(() => {
        apiDispatch(getRecentlyViewedUsers());
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <FormSection className={recentlyViewedSection}>
            <div className={recentlyViewedSectionRecordsList}>
                {!!recentlyViewedUsers.length && (
                    <Scroll>
                        <ul>
                            {recentlyViewedUsers.map(user => {
                                const {userId, firstName, lastName, email} = user;

                                const shownData = firstName || lastName
                                    ? [firstName, lastName].filter(Boolean).join(' ')
                                    : email;

                                return (
                                    <li
                                        key={userId}
                                        className={recentlyViewedSectionRecord}>
                                        <UserLink place="Recently Viewed Users" userId={userId} caption={shownData}/>
                                    </li>
                                );
                            })}
                        </ul>
                    </Scroll>
                )}
            </div>
        </FormSection>
    );
};
